import React from 'react'
import { useState } from 'react'
import { Button, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap'

export default function SoDocument(props) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button className='nexogic-btn-link'
                id={props.id}
                type="button" onClick={()=>setIsOpen(!isOpen)}
            >
                <div className="card-text"><span className="icon"><svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      fill="none"
      viewBox="0 0 18 22"
    >
      <path
        stroke="#3EABCA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 1H3a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7m-6-6l6 6m-6-6v6h6m-4 5H5m8 4H5m2-8H5"
      ></path>
    </svg></span><b className='no-colon'>Documents </b>(2)</div>
            </Button>
            <UncontrolledPopover
                isOpen={isOpen}
                placement="bottom"
                target={props.id}
                trigger="click"
                className='nexogic-document-popover'
            >
                <PopoverBody className='nexogic-popover'>
                    <h3 className="card-title popover-title">Documents <span className='popover-close-btn' onClick={()=>setIsOpen(false)}>&times;</span></h3>
                    <div className="nexogic-custom-scroll">
                    <div className="nexogic-document-lists">
                        <ul>
                            <li>
                                <div className="nexogic-document-item">
                                    <div className="graphic">
                                    <svg className='icon'
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="26"
                                        height="32"
                                        fill="none"
                                        viewBox="0 0 26 32"
                                        >
                                        <path
                                            stroke="#3EABCA"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M16 1H4a3 3 0 00-3 3v24a3 3 0 003 3h18a3 3 0 003-3V10m-9-9l9 9m-9-9v9h9m-6 7.5H7m12 6H7m3-12H7"
                                        ></path>
                                        </svg>
                                    </div>
                                    <div className="info">
                                        <div className="document-text">
                                            <h3 className="card-title">Prescription <span className='text-muted'>2h ago</span></h3>
                                            <p className='card-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="nexogic-document-item">
                                    <div className="graphic">
                                    <svg className='icon'
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="26"
                                        height="32"
                                        fill="none"
                                        viewBox="0 0 26 32"
                                        >
                                        <path
                                            stroke="#3EABCA"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M16 1H4a3 3 0 00-3 3v24a3 3 0 003 3h18a3 3 0 003-3V10m-9-9l9 9m-9-9v9h9m-6 7.5H7m12 6H7m3-12H7"
                                        ></path>
                                        </svg>
                                    </div>
                                    <div className="info">
                                        <div className="document-text">
                                            <h3 className="card-title">Prescription <span className='text-muted'>2h ago</span></h3>
                                            <p className='card-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
                    </div>
                </PopoverBody>
            </UncontrolledPopover>
        </>

    )
}
